// @flow strict
import _get from 'lodash.get'
import * as React from 'react'
import BlogCard from '../BlogCard/BlogCard'
import styles from './PostListing.module.scss'

export type Props<T> = {
  posts: Array<T>,
}

const PostListing = <T>({ posts }: Props<T>) => (
  <ul className={styles.list}>
    {posts &&
      posts.map((post, i) => {
        const id = _get(post, 'id', '')

        return (
          <li className={styles.item} key={id}>
            <BlogCard post={post} />
          </li>
        )
      })}
  </ul>
)

export default PostListing
